import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AppContext } from 'context';
import { useAction } from 'hooks';
import XIcon from 'svg/x.svg';
import Button from 'components/Form/Button';
import { globalConsentsTemplate as consentsTemplateSelector } from 'modules/Information/selectors';
import * as actions from '../../actions';
import messages from '../../messages';
import LegalConsentLabel from '../LegalConsentLabel';
import { ALLOW_COOKIES } from './constants';
import styles from './CookiesInfo.pcss';
const CookiesInfo = ()=>{
    useStyles(styles);
    const { cookies } = useContext(AppContext);
    const isCookiesAllowed = cookies.get(ALLOW_COOKIES);
    const consentsTemplate = useSelector(consentsTemplateSelector);
    const allowCookies = useAction(actions.setAllowCookies);
    const [showCookiesInfo, setShowCookiesInfo] = useState(!isCookiesAllowed);
    const cookiePolicyConsent = consentsTemplate.find((c)=>c.type === 'CookiePolicy');
    const onCookiesAccept = ()=>{
        allowCookies(1);
        setShowCookiesInfo(false);
    };
    const onCookiesReject = ()=>{
        allowCookies(0);
        setShowCookiesInfo(false);
    };
    const onCloseCookiesWidget = ()=>{
        setShowCookiesInfo(false);
    };
    if (!showCookiesInfo || !cookiePolicyConsent) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cookiesBox,
        "data-testid": "accept-cookies",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.cookiesBox__closeWrapper,
                onClick: onCloseCookiesWidget,
                children: /*#__PURE__*/ _jsx(XIcon, {
                    className: styles.cookiesBox__closeIcon
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.cookiesBox__content,
                children: /*#__PURE__*/ _jsx(LegalConsentLabel, {
                    legalConsent: cookiePolicyConsent
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.acceptAllCookies,
                className: "btn--block btn--filled mb-0",
                onClick: onCookiesAccept
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.reject,
                className: "btn--block mt-5 mb-0",
                onClick: onCookiesReject
            })
        ]
    });
};
export default CookiesInfo;
